import React, {useCallback, useEffect, useState,} from 'react';
import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import './css/index.scss';

import glowImages from './images/blue-glow.png';
import glowImages2 from './images/blue-glow-pink.png';
import DOMPurify from "dompurify";


// import paginationFactory from 'react-bootstrap-table2-paginator';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { getData, getPromoTemplate } from "../../../store/slices/http";
import { useDispatch, useSelector } from "react-redux";
// import { commonActions } from '../../../store/slices/common';
import { useParams } from 'react-router-dom';
import {convertLanguageCode, DEFAULT_LANGUAGE} from "../../../helper/language";


i18n.on('languageChanged', (lng) => { document.documentElement.setAttribute('lang', lng); })

const DEFAULT_WINNING_TABLE_HEADERS = ["rank", "username", "prize"];

export const PromotionChild = () => {
    const { t, i18n } = useTranslation();
    const websitePromo = t('WEBSITE_PROMO', { returnObjects: true });
    const dispatch = useDispatch();

    const params = useParams();

    const promoData = useSelector(state => state.http.promoData)
    let promoTemplateData = useSelector((state) => state.http.promoTemplate);

    const [promoTemplate, setPromoTemplate] = useState(null);

    useEffect(()=>{
        const t = getPromoTemplateData(promoTemplateData, i18n.language, params.id);

        const template = {
            bannerUrl: t?.bannerUrl,
            headers: t?.winningTableHeaders && t.winningTableHeaders.length > 0 ?
              t.winningTableHeaders: DEFAULT_WINNING_TABLE_HEADERS,
            myHTML: DOMPurify.sanitize(t?.mechanics, {
                FORCE_BODY: true,
                ALLOWED_ATTR: ['style', 'class', 'type', 'href', 'rel', 'colspan', 'rowspan'],
                ALLOWED_TAGS: ['a', 'em', 'i', 'strong', 'b', 'br', 'p', 'blockquote', 'ul', 'ol', 'li', 'dl', 'dt', 'dd', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', "table", "col", "tr", "td", "th", "tbody", "thead", "colgroup", "span", "figure"],
            }),
            mySafeHTMLPrizes: DOMPurify.sanitize(t?.prizeDetail, {
                FORCE_BODY: true,
                ALLOWED_ATTR: ['style', 'class', 'type', 'href', 'rel', 'colspan', 'rowspan'],
                ALLOWED_TAGS: ['a', 'em', 'i', 'strong', 'b', 'br', 'p', 'blockquote', 'ul', 'ol', 'li', 'dl', 'dt', 'dd', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', "table", "col", "tr", "td", "th", "tbody", "thead", "colgroup", "span", "figure"],
            }),
        }

        setPromoTemplate(template);
    }, [promoTemplateData, i18n.language, params.id]);

    function getPromoTemplateData(templates, language, promoId) {
        let templateByLanguage = {};
        if (templates) {
            templates
              .filter((template) => template.promotionId === +promoId)  //transfer string to integer
              .forEach((template) => {
                  const lang = convertLanguageCode(template.language);
                  templateByLanguage[lang] = template;
              });
        }

        return templateByLanguage[language] ?? templateByLanguage[DEFAULT_LANGUAGE];
    }

    let leaderBoard = [];
    if (promoData && promoData.length) {
        promoData.forEach((n, i) => {
            leaderBoard.push({
                username: n.username,
                rank: i + 1,
                prize: (n.prize === 0 ? "-" : "CNY " + n.prize.toLocaleString()),
                betCode: n.betCode,
                stage: n.stage,
                date: n.date,
            })
        });
    }



    const createTable = () => {
        let table = []
        // Outer loop to create parent
        for (let i = 0; i < leaderBoard.length; i++) {
            let children = []
            //Inner loop to create children
            const headers = promoTemplate?.headers??DEFAULT_WINNING_TABLE_HEADERS;
            for (let j = 0; j < headers.length; j++) {
                children.push(<td key={headers[j]}>{leaderBoard[i][headers[j]]}</td>)
            }
            //Create the parent and add the children
            table.push(<tr key={leaderBoard[i].rank}>{children}</tr>)
        }
        //translationMethod()
        return table
    }


    useEffect(() => {

        dispatch(getData(`promotionId=${params.id}`));
        dispatch(getPromoTemplate())

    }, [dispatch, params])


    const particlesInit = useCallback(async (engine) => {
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);
    const particlesLoaded = useCallback(async (container) => {
    }, []);
    const options = {
        background: {
            color: {
                value: "#0d47a1",
            },
        },
        fpsLimit: 120,
        interactivity: {
            events: {
                onHover: {
                    enable: false,
                    mode: "bubble",
                    parallax: {
                        enable: true,
                        force: 10,
                        smooth: 20
                    }
                }
            },
            modes: {
                bubble: {
                    distance: 150,
                    duration: 2,
                    opacity: 10,
                    size: 5,
                    speed: 15
                }
            },
        },
        particles: {
            move: {
                direction: "none",
                distance: 50,
                enable: true,
                outModes: "none",
                speed: 1
            },
            number: {
                value: 40
            },
            color: {
                value: ["#ff30b5", "#27aef3"]
            },
            shape: {
                type: "images",
                options: {
                    images: [
                        {
                            src: glowImages,
                            width: 20,
                            height: 20
                        },
                        {
                            src: glowImages2,
                            width: 20,
                            height: 20
                        },
                    ]
                }
            },
            opacity: {
                value: 1,
                random: false,
                animation: {
                    enable: true,
                    speed: .5,
                    minimumValue: 0.1,
                    sync: false
                }
            },
            size: {
                value: {
                    min: 15,
                    max: 25
                },
                random: true,
                animation: {
                    enable: true,
                    speed: 12.181158184520175,
                    minimumValue: 0.1,
                    sync: false
                },
            }
        },
        canvasMask: {
            enable: true,
            scale: 10,
            pixels: {
                filter: "pixelFilter"
            },
            image: {
                src: "https://particles.js.org/images/amongus_cyan.png"
            }
        },
        detectRetina: true,
    }


    return (
        <React.Fragment>

            <div className="bg-content1">
                <div className="new-promo">
                    <div className="main-wrapper">
                        <div className="banner text-center">
                            <img src={promoTemplate?.bannerUrl} alt="11-11 PROMO" />
                        </div>

                        <div className="promotion-mech">
                            <h2 data-aos="fade" data-aos-delay={100} data-aos-offset="-80">
                                <span>{websitePromo.PROMO_MECHANICS}</span>
                                <span className="back-text">{websitePromo.PROMO_MECHANICS}</span>
                            </h2>

                            <div className='valueHtml' dangerouslySetInnerHTML={{ __html: promoTemplate?.myHTML }} />

                        </div>

                        <div className="prizes">
                            <h2 data-aos="fade" data-aos-delay={100} data-aos-offset="-80">
                                <span>{websitePromo.PROMO_PRIZES}</span>
                                <span className="back-text">{websitePromo.PROMO_PRIZES}</span>
                            </h2>

                            <div className='valueHtml'>
                                <div className='valueHtmlChild2' dangerouslySetInnerHTML={{ __html: promoTemplate?.mySafeHTMLPrizes }} />
                            </div>
                        </div>

                        <div className="winning">
                            <h2 data-aos="fade" data-aos-delay={100} data-aos-offset="-80">
                                <span>{websitePromo.PROMO_WINNING}</span>
                                <span className="back-text">{websitePromo.PROMO_WINNING}</span>
                            </h2>

                            <table>
                                <thead data-aos="fade" data-aos-delay={100} data-aos-offset="100">
                                    <tr>
                                        {promoTemplate?.headers?.map(header => (
                                            <th key={header}>{websitePromo[header.toUpperCase()]}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        createTable()
                                    }
                                </tbody>
                            </table>
                        </div>


                    </div>
                    <Particles id="tsparticles" init={particlesInit} loaded={particlesLoaded} options={options} />
                </div>
            </div>
        </React.Fragment >
    )
}
